<template>
  <div class="container h-max w-max">
    <div id="a1" style="background-image: url(static/shutterstock_272645438.png);" class="h-max w-max front-img">
        <div style="height:40%;" class="w-max front-logo">
          <div class="p-t-sm p-l-md" style="width: 8rem;">
            <p><img src="static/keepyou.fit.svg" class="icon is-xlarge"></p>
        </div>
        <div class="m-t-xs m-r-sm is-flex" style="width:46px;height:46px;position: absolute;right:0;top:0;border:2px solid #aaaaaa;align-items:center;text-align:center;align-content:center;border-radius: 46px;">
            <router-link :to="{ name: 'Home' }"><img src="static/icons/cancel.png" style="display: block;height: 42px;width: 42px;"></router-link>
        </div>
    </div>
        <div style="height:60%;background-color: #2c272b !important;" class="has-text-centered p-t-md ">
            <p>บริการ Quality fitness video อัตราค่าบริการ 10 บาท/SMS คุณจะได้รับ 1SMS/วัน</p>
            <p>เฉพาะผู้ใช้บริการเครือข่าย AIS เท่านั้น</p>
            <br>
            
            <a @click="confirm" class="button is-primary is-rounded is-size-4 p-l-xl p-r-xl m-b-md m-t-md  is-uppercase has-text-weight-bold">สมัครสมาชิก</a>
            <p class="is-size-6 p-sm">
              หรือ สมัครโดยพิมพ์ B4 ส่งมาที่ 4541372<br>
              สอบถามโทร : 02-1158814, 9.00 - 18.00 (จันทร์ - ศุกร์)<br>
              ยกเลิกพิมพ์ STOP B4 ส่งมาที่ 4541372
            </p>
        </div>
  </div>
  <div class="has-text-centered fixed-bl is-fullwidth is-uppercase has-text-weight-bold">
    <div class="has-text-left is-size-6 has-text-grey is-family-secondary">
      <a class="has-text-grey m-r-sm m-l-sm" href="http://th.keepyou.fit/#/terms-and-conditions">T & C</a> |
      <a class="has-text-grey m-r-sm m-l-sm" href="http://th.keepyou.fit/#/imprint">Imprint</a> |
      <a class="has-text-grey m-r-sm m-l-sm" href="http://th.keepyou.fit/#/help">Help</a>
    </div>
  </div>
  </div>
</template>

<script>
import axios from 'axios'
import Header from '@/components/LangKyf/Header'
import Footer from '@/components/LangKyf/Footer'

export default {
  name: 'Statisitc',
  data () {
    let link = `http://th.keepyou.fit/`
    const requestIdArr = document.location.toString().match(/request_id=(.*)/)
    if (requestIdArr !== null) {
      link = `http://th.keepyou.fit/?${ requestIdArr[0] }`
    }
    return {
      link,
      requestIdQuery: requestIdArr[0],
      carrier: 3
    }
  },
  async mounted() {
    if (this.$store.getters.requireSaleId && window !== undefined && window.localStorage instanceof Storage && window.localStorage.getItem('saleId') !== null) {
      const result = await axios.get(`/${ this.$store.getters.apiPrefix }/checkSale/${ window.localStorage.getItem('saleId') }`)
      if (result.data.state === 'open') {
        this.$router.push({ name: 'Home' })
      }
    }
  },
  methods: {
    confirm () {
      window.location.href = 'http://th.keepyou.fit/macrokiosk/lp/th-b4?carrier=' + this.carrier + '&' + this.requestIdQuery
    }
  },
  components: {
    Header,
    Footer
  }
}
</script>

<style>
.is-vertical-center {
display: flex;
align-items: center;
}
.shadow {
-webkit-box-shadow: 5px 5px 10px 5px rgba(0,0,0,0.1);
-moz-box-shadow: 5px 5px 10px 5px rgba(0,0,0,0.1);
box-shadow: 5px 5px 10px 5px rgba(0,0,0,0.1);
}
.steps .steps-marker {
    background: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.1) 100%);
}

.h-max {
    min-height: 100%;
    height: 100%;
}
.w-max {
    min-width: 100%;
    width: 100%;
}
.fixed-tl {
    position: fixed;
    top:0;
    left: 0;
}
.fixed-bl {
    position: fixed;
    bottom:0;
    left: 0;
}
.fixed-tr {
    position: fixed;
    top:0;
    right: 0;
}
.fixed-br {
    position: fixed;
    bottom:0;
    right: 0;
}
.lh-1 {
    line-height: 1 !important;
}
.bg-point {
    background-color: transparent;
    background-image: radial-gradient(#f99819 50%, transparent 51%, transparent 60%, #f99819 61%, #f99819 65%, transparent 66%);
}

.front-img {
    background-repeat: no-repeat;
    background-position: top center;
    background-size: auto 120%;
    max-width: 45rem;
    margin: 0 auto;
    position: relative;
    min-width: auto;
}
.invert-img {
    background-repeat: no-repeat;
    background-position: top center;
    background-size: 100% auto;
}
@media screen and (orientation:landscape) {
    .front-img {
        background-size: 100% auto;
    }
    .invert-img {
        background-size: auto 100%;
        background-position: top left;
    }
    .front-logo {
        display: block;
    }
    .is-portrait {
        display: none;
    }
}
@media screen and (orientation:portrait) {
    .is-landscape {
        display: none;
    }
    .front-img {
        background-size: auto 55%;
    }
    .lp-logo {
        position: absolute;
        bottom: 40%;
        margin-bottom: -7.2rem;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/LangKyf/TH/LP2.vue